"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const __1 = require("../../..");
const type_1 = require("../../../type");
const Field_Constant_1 = require("../utils/Field.Constant");
// const FieldOTP = ({ props }) => {
//   const createArray = new Array(props.count).fill("");
//   const [thisValue, setThisValue] = React.useState(createArray);
//   const [currentIndex, setCurrentIndex] = React.useState(0);
//   const [loaded, setLoaded] = React.useState(false);
//   React.useEffect(() => {
//     if (window !== undefined) {
//       props.reference.current[currentIndex].focus();
//       if (currentIndex === props.count && thisValue[props.count - 1] !== "") {
//         const result = thisValue.join("");
//         props.setValue(result);
//         props.trigger(result);
//       } else {
//         return;
//       }
//     } else {
//       return;
//     }
//   }, [currentIndex, props.reference.current]);
//   React.useEffect(() => {
//     if (props.reference.current === "" && loaded === false) {
//       props.reference.current = [];
//       setLoaded(true);
//     }
//   }, [props.reference]);
//   if (loaded) {
//     return (
//       <React.Fragment>
//         {createArray?.map((_, i) => {
//           const none = thisValue[i - 1] === "" && i !== 0;
//           const hasLength = thisValue[i]?.length > 0 && i !== props.count - 1;
//           return (
//             <input
//               type="number"
//               className={`${TEXT_AUTHOR}-input ${
//                 typeof props.classNameInput === TYPE_FUNCTION
//                   ? props.classNameInput({ ...props, inputIndex: i })
//                   : props.classNameInputf
//               }`}
//               ref={(ref) => {
//                 props.reference.current[i] = ref;
//               }}
//               key={i}
//               id={`otp-index-${i}`}
//               onKeyUp={(e) => {
//                 const isDelete = e.key === "Backspace";
//                 if (isDelete) {
//                   setThisValue((prev) => {
//                     const newValue = [...prev];
//                     newValue[i - 1] = "";
//                     return newValue;
//                   });
//                   setCurrentIndex(i - 1);
//                 }
//               }}
//               value={thisValue[i]}
//               disabled={none || hasLength}
//               onChange={(e) => {
//                 const value = e.target.value;
//                 if (value?.length <= 1) {
//                   setThisValue((prev) => {
//                     const newValue = [...prev];
//                     newValue[i] = value;
//                     return [...newValue];
//                   });
//                   if (currentIndex < props.count) {
//                     setCurrentIndex(i + 1);
//                   } else {
//                     return;
//                   }
//                 } else {
//                   return;
//                 }
//               }}
//             />
//           );
//         })}
//       </React.Fragment>
//     );
//   } else {
//     return <React.Fragment />;
//   }
// };
const FieldOTP = ({ props }) => {
    const createArray = new Array(props.count).fill("");
    const [thisValue, setThisValue] = React.useState(createArray);
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const [loaded, setLoaded] = React.useState(false);
    React.useEffect(() => {
        var _a;
        if (window !== undefined) {
            (_a = props.reference.current[currentIndex]) === null || _a === void 0 ? void 0 : _a.focus();
            if (currentIndex === props.count && thisValue[props.count - 1] !== "") {
                const result = thisValue.join("");
                props.setValue(result);
                props.trigger(result);
            }
            else {
                return;
            }
        }
        else {
            return;
        }
    }, [currentIndex, props.reference.current]);
    React.useEffect(() => {
        if (loaded === false) {
            props.reference.current = [];
            setLoaded(true);
        }
    }, [props.reference]);
    React.useEffect(() => {
        if (window) {
            window === null || window === void 0 ? void 0 : window.addEventListener("paste", (event) => {
                const paste = ((event === null || event === void 0 ? void 0 : event.clipboardData) || (window === null || window === void 0 ? void 0 : window.clipboardData)).getData("text");
                if (paste.length === props.count) {
                    props.setValue(paste);
                    props.trigger(paste);
                    setThisValue(paste.split(""));
                }
            });
        }
    }, []);
    React.useEffect(() => {
        var _a;
        if (((_a = props === null || props === void 0 ? void 0 : props.value) === null || _a === void 0 ? void 0 : _a.length) === (props === null || props === void 0 ? void 0 : props.count)) {
            FunctionTrigger();
        }
    }, [props === null || props === void 0 ? void 0 : props.value]);
    const FunctionTrigger = () => __awaiter(void 0, void 0, void 0, function* () {
        const clone = (0, __1.FunctionCloneDeep)(props === null || props === void 0 ? void 0 : props.value);
        yield props.trigger(clone);
    });
    if (loaded) {
        return (React.createElement(React.Fragment, null, createArray === null || createArray === void 0 ? void 0 : createArray.map((_, i) => {
            var _a;
            const none = thisValue[i - 1] === "" && i !== 0;
            const hasLength = ((_a = thisValue[i]) === null || _a === void 0 ? void 0 : _a.length) > 0 && i !== props.count - 1;
            return (React.createElement("input", { type: "number", className: `${Field_Constant_1.TEXT_AUTHOR}-input ${typeof props.classNameInput === type_1.TYPE_FUNCTION
                    ? props.classNameInput(Object.assign(Object.assign({}, props), { inputIndex: i }))
                    : props.classNameInputf}`, ref: (ref) => {
                    props.reference.current[i] = ref;
                }, key: i, id: `otp-index-${i}`, pattern: "[0-9]*", onKeyUp: (e) => {
                    const isDelete = e.key === "Backspace";
                    if (isDelete) {
                        setThisValue((prev) => {
                            const newValue = [...prev];
                            newValue[i - 1] = "";
                            return newValue;
                        });
                        props.reference.current[i - 1].value = "";
                        setCurrentIndex(i - 1);
                    }
                }, onClick: (e) => {
                    var _a;
                    if (none || hasLength) {
                        (_a = props.reference.current[currentIndex]) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                }, onChange: (e) => {
                    const value = e.target.value;
                    if ((value === null || value === void 0 ? void 0 : value.length) <= 1) {
                        setThisValue((prev) => {
                            const newValue = [...prev];
                            newValue[i] = value;
                            return [...newValue];
                        });
                        if (currentIndex < props.count) {
                            setCurrentIndex(i + 1);
                        }
                        else {
                            return;
                        }
                    }
                    else if ((value === null || value === void 0 ? void 0 : value.length) === (props === null || props === void 0 ? void 0 : props.count)) {
                        value.split("").map((_, i) => {
                            props.reference.current[i].value = value[i];
                        });
                        props.setValue(value);
                    }
                    else {
                        return;
                    }
                } }));
        })));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
exports.default = FieldOTP;
